<template>
  <div class="counter">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  .counter {
    width: 60px;
    height: 60px;
    background: #f2ae43;
    border-radius: 100px;
    color: #fff;
    margin: 0 auto;
    font-size: 35px;
    font-weight: bold;
    text-align: center;
    line-height: 60px;
    margin-top: -40px;
    margin-bottom: 40px;
  }
</style>